import { DirectMessageService } from '@/components/pages/conversations/SocialInbox/services/DirectMessageService';

import { DMConversationMessage } from '@/components/pages/conversations/SocialInbox/types';

type DirectMessageBubbleContentProps = {
    message: DMConversationMessage;
    awsTranslation: any;
};

export const DirectMessageBubbleContent = ({
    awsTranslation,
    message
}: DirectMessageBubbleContentProps) => {
    let content = message.content;
    if (awsTranslation) {
        content = awsTranslation?.isDisplayed
            ? awsTranslation?.translated
            : awsTranslation?.original;
    }

    const segments = DirectMessageService.parseLinks(content);

    return (
        <span className="whitespace-pre-wrap font-GMedium text-sm">
            {segments.map((segment) =>
                segment.isUrl ? (
                    <a
                        key={segment.text}
                        href={segment.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={
                            !message?.is_from_me
                                ? 'underline hover:text-icoBlue'
                                : 'underline hover:text-white hover:text-opacity-60'
                        }>
                        {segment.text}
                    </a>
                ) : (
                    segment.text
                )
            )}
        </span>
    );
};
